import { defineMessages } from 'react-intl';

export const RecoveryPageMessages = defineMessages({
  headTitle: {
    id: 'login.head.title',
    defaultMessage: 'Log in to continue',
  },
});
